import { registerSession } from '../api/registerSession.js';
import { validateViewdocsForm } from './validateViewdocsForm.js';
import { getViewdocsView, getViewdocsViewBtnSubmit, hideViewdocsError } from './getViewdocsView.js';
import { RESULT_HIDE_LOADER } from '../../../login/src/form/constant.js';
import progressBar from '../../../shared/DOM/progressBar.js';
import { renderViewdocsHeader } from './renderViewdocsHeader.js';
import { renderOtp } from './otp/renderOtp.js';
import { INCORRECT_ACCESS, onCatchError, renderError } from './renderError.js';
import { renderViewDocsWorkflow } from './workflow/renderViewDocsWorkflow.js';
import { isDocumentValid } from '../api/isDocumentValid.js';

export async function renderViewdocs(viewdocsParams) {
  // Lo dejamos preparado por si saltamos a OTP / Error
  viewdocsParams.form = 1;
  document.getElementById('container-form').insertAdjacentHTML('afterbegin', `<ewc-form id="form-viewdocs${viewdocsParams.form}" autofocus></ewc-form>`);

  // Evaluamos link
  if (isDocumentValid(viewdocsParams)) {
    if (viewdocsParams.ta) {
      if (viewdocsParams.printOtpRequired) {
        renderOtp(viewdocsParams.ta, viewdocsParams, true);
        return RESULT_HIDE_LOADER;
      } else {
        renderViewDocsWorkflow(viewdocsParams.ta, viewdocsParams);
        return RESULT_HIDE_LOADER;
      }
    } else if (isUserValid(viewdocsParams)) {
      // Nos quedamos en viewdocsForm
      renderViewdocsForm(viewdocsParams);
      return RESULT_HIDE_LOADER;
    }
  }

  // Exit with error
  renderError(INCORRECT_ACCESS, viewdocsParams);
  return RESULT_HIDE_LOADER;
}

function isUserValid(viewdocs) {
  return viewdocs.user && viewdocs.domain && viewdocs.group;
}

export function renderViewdocsForm(viewdocsParams, clean) {
  if (clean) {
    // Creamos un nuevo form, mejor solución que recargar
    viewdocsParams.form++;
    document.getElementById('container-form').innerHTML = `<ewc-form id="form-viewdocs${viewdocsParams.form}" autofocus></ewc-form>`;
  }

  const eForm = createViewdocsForm(viewdocsParams);
  const eBtnSubmit = getViewdocsViewBtnSubmit();

  initViewdocsForm(eForm, eBtnSubmit, submitViewdocsForm);

  /////////////////////////////

  // eBtnSubmit
  async function submitViewdocsForm() {
    // Bloqueamos peticiones simultáneas (intro)
    if (eBtnSubmit.state === 'loading') {
      return;
    }

    try {
      eBtnSubmit.state = 'loading';
      progressBar.loading();

      const viewdocsForm = eForm.value;

      // eForm.valid personalizado
      const valid = validateViewdocsForm(viewdocsForm);

      // Exit error
      if (!valid) {
        eBtnSubmit.state = 'rejected';
        progressBar.rejected();
        return;
      }

      // set
      viewdocsParams.password = viewdocsForm.password;

      const tokena = await registerSession(viewdocsParams);
      if (tokena) {
        renderViewDocsWorkflow(tokena, viewdocsParams);
      }
      // else no token + no error > navigateTo OTP

      // Finalizamos correctamente por si navegan hacia atrás en el navegador:
      progressBar.resolved();
      // Con retardo para visualizar solo el check de ok
      setTimeout(() => {
        eBtnSubmit.state = 'resolved';
      }, 1000);
    } catch (e) {
      eBtnSubmit.state = 'rejected';
      progressBar.rejected();
      onCatchError(e, viewdocsParams);
    }
  }
}

function createViewdocsForm({ user, form }) {
  const eForm = document.getElementById(`form-viewdocs${form}`);
  eForm.render({
    value: {
      user,
      password: '',
    },
    view: getViewdocsView(),
  });

  renderViewdocsHeader('check', 'viewdoc.step.intro.title');

  hideViewdocsError();

  return eForm;
}

function initViewdocsForm(eForm, eBtnSubmit, submitViewdocsForm) {
  eForm.addEventListener('keyup', (event) => {
    if (event.key === 'Enter' && eBtnSubmit === getViewdocsViewBtnSubmit()) {
      submitViewdocsForm();
    }
  });

  eForm.addEventListener('click', (event) => {
    const target = event?.detail?.target ?? event?.target;

    if (eBtnSubmit === target) {
      submitViewdocsForm();
    }
  });
}
